import React, { useEffect, useState } from "react"
import { Card, CardBody, Modal, ModalBody } from "reactstrap"
import { useClientContext } from "../ClientContextBox"
import LoadingButton from "components/Common/LoadingButton"
import { axiosbaseurl } from "configure"
import moment from "moment"
import { sanitizeNumber, validateContact } from "helpers/common_helper"
import VATServiceDateCalculate from "../components/VATServiceDateCalculate"

const TaxReferences = ({ changeStep, client_id }) => {
  const {
    errors,
    setErrors,
    isReadOnly,
    payroll_freq_options,
    vat_period_options,
    clientName,
    utr,
    setUtr,
    pc,
    setPc,
    cac,
    setCac,
    insurance,
    setInsurance,
    paye,
    setPaye,
    vat,
    setVat,
    auditLogs,
    setAuditLogs,
    accountsAndTaxCurrentYearDueDate,
    setAccountsAndTaxCurrentYearDueDate,
    accountsAndTaxNextYearDueDate,
    setAccountsAndTaxNextYearDueDate,
    VATFirstPeriod,
    setVATFirstPeriod,
    VATCurrentPeriodDueDate,
    setVATCurrentPeriodDueDate,
    VATFrequency,
    setVATFrequency,
    VATCurrentPeriodEnd,
    setVATCurrentPeriodEnd,
    isVatPresent,
    setVatPresent,
    CISDate,
    setCISDate,
    CISDueDate,
    setDueCISDate,
    CISFrequency,
    setCISFrequency,
    PAYEDate,
    setPAYEDate,
    payrollFrequency,
    setpayrollFrequency,
    payrollWeeklyDate,
    setPayrollWeeklyDate,
    payrollWeeklyDueDate,
    setPayrollWeeklyDueDate,
    payrollFortNightlyDate,
    setPayrollFortNightlyDate,
    payrollFortNightlyDueDate,
    setPayrollFortNightlyDueDate,
    payrollForWeeklyDate,
    setPayrollForWeeklyDate,
    payrollForWeeklyDueDate,
    setPayrollForWeeklyDueDate,
    payrollMonthlyDate,
    setPayrollMonthlyDate,
    payrollMonthlyDueDate,
    setPayrollMonthlyDueDate,
    clientId,
    static_frequency,
    setIsChanged,
    clientType,
    currentMTDPeriodEnd,
    currentMTDPeriodDue,
    officerIdStatus,
    setOfficerIdStatus,
    officerId,
    setOfficerId,
  } = useClientContext()

  const [show, setShow] = useState(false)
  const [historyType, setHistoryType] = useState(null)
  const [history, setHistory] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (historyType)
      setHistory(auditLogs.filter(item => item.module === historyType))
  }, [historyType])

  const validate = () => {
    let tempErrors = {}

    if (!utr?.isApplied) tempErrors.utrIsApplied = "This is required."
    if (utr?.isApplied === "yes") {
      if (!utr?.appliedDate) tempErrors.utrAppliedDate = "This is required."
    }

    // Check for each field
    if (!utr?.status) tempErrors.utrStatus = "UTR Status required."

    if (utr?.status === "Received") {
      if (!utr?.number) tempErrors.utrNumber = "UTR No. is required."
      // if (
      //   !utr?.letterLocation ||
      //   !utr?.letterLocation?.startsWith("https://") ||
      //   !utr?.letterLocation?.includes('sharepoint')
      // )
      //   tempErrors.utrletter = "Valid Letter Location required."

      if (!utr?.isAgentAuthorisationApplied)
        tempErrors.utrAuthApplied = "This is required"

      if (utr?.isAgentAuthorisationApplied === "yes") {
        if (!utr?.agentAuthorisationAppliedDate)
          tempErrors.utrAuthAppliedDate = "This is required"
        if (!utr?.agentAuthorisationStatus)
          tempErrors.utrAuthStatus = "This is required"

        if (utr?.agentAuthorisationStatus === "Received") {
          if (!utr?.authorisationCode)
            tempErrors.utrAuthCode = "This is required"
        }
      }
    }

    if (utr?.status === "N/A") {
      if (!utr?.whyUTRNotApplicable?.trim()) {
        tempErrors.utrNotApplicableReason =
          "Reason is required when UTR Status is N/A."
      }
    }

    if (clientType === 1) {
      if (!pc?.isApplied) tempErrors.pcIsApplied = "This is required."
      if (pc?.isApplied === "yes") {
        if (!pc?.appliedDate) tempErrors.pcAppliedDate = "This is required."
      }
      if (!pc?.status) tempErrors.pcStatus = "Personal Code Status required."
      if (pc?.status === "Received") {
        if (!pc?.number) tempErrors.pcNumber = "Personal Code is required."
      }
      if (pc?.status === "N/A") {
        if (!pc?.whyPersonalCodeNotApplicable?.trim()) {
          tempErrors.pcNotApplicableReason =
            "Reason is required when Personal Code Status is N/A."
        }
      }
    }

    if (clientType !== 1 && !cac?.isApplied) {
      tempErrors.cacIsApplied = "This is required."
    }
    if (cac?.isApplied === "yes") {
      if (!cac?.appliedDate) tempErrors.cacAppliedDate = "This is required."
    }

    if (cac?.status === "Received") {
      // if (
      //   !cac?.letterLocation ||
      //   !cac?.letterLocation?.startsWith("https://") ||
      //   !cac?.letterLocation?.includes('sharepoint')
      // )
      //   tempErrors.cacletter = "Valid Letter Location required"

      if (!cac?.number) tempErrors.cacNumber = "CAC Number required."

      // if (!cac?.isAgentAuthorisationApplied)
      //   tempErrors.cacAuthApplied = "This is required"

      // if (cac?.isAgentAuthorisationApplied === "yes") {
      //   if (!cac?.agentAuthorisationAppliedDate)
      //     tempErrors.cacAuthAppliedDate = "This is required"
      //   if (!cac?.agentAuthorisationStatus)
      //     tempErrors.cacAuthStatus = "This is required"

      //   if (cac?.agentAuthorisationStatus === "Received") {
      //     if (!cac?.authorisationCode)
      //       tempErrors.cacAuthCode = "This is required"
      //   }
      // }
    }

    if (insurance?.status === "Received") {
      // if (
      //   !insurance?.letterLocation ||
      //   !insurance?.letterLocation?.startsWith("https://") ||
      //   !insurance?.letterLocation?.includes('sharepoint')
      // )
      //   tempErrors.insuranceletter = "Valid Letter Location required"

      if (!insurance?.number)
        tempErrors.insuranceNumber = "Insurance Number required."
    }

    if (!paye?.isApplied) tempErrors.payeIsApplied = "This is required."
    if (paye?.isApplied === "yes") {
      if (!paye?.appliedDate) tempErrors.payeAppliedDate = "This is required."
    }

    if (paye?.status === "Received") {
      // if (
      //   !paye?.letterLocation ||
      //   !paye?.letterLocation?.startsWith("https://") ||
      //   !paye?.letterLocation?.includes('sharepoint')
      // )
      //   tempErrors.payeletter = "Valid Letter Location required."

      if (!paye?.number) tempErrors.payeNumber = "PAYE Number required."

      if (!paye?.officeReference)
        tempErrors.payeReference = "Office Reference required."

      if (!paye?.isAgentAuthorisationApplied)
        tempErrors.payeAuthApplied = "This is required"

      if (paye?.isAgentAuthorisationApplied === "yes") {
        if (!paye?.agentAuthorisationAppliedDate)
          tempErrors.payeAuthAppliedDate = "This is required"
        if (!paye?.agentAuthorisationStatus)
          tempErrors.payeAuthStatus = "This is required"

        if (paye?.agentAuthorisationStatus === "Received") {
          if (!paye?.authorisationCode)
            tempErrors.payeAuthCode = "This is required"
        }
      }
    }

    if (!vat?.isApplied) tempErrors.vatIsApplied = "This is required."

    if (vat?.isApplied === "yes") {
      if (!vat?.appliedDate) tempErrors.vatAppliedDate = "This is required."
    }

    if (vat?.status === "Received") {
      // if (
      //   !vat?.letterLocation ||
      //   !vat?.letterLocation?.startsWith("https://") ||
      //   !vat?.letterLocation?.includes('sharepoint')
      // )
      //   tempErrors.vatletter = "Valid Letter Location required."

      if (!vat?.number) tempErrors.vatNumber = "VAT Number required."

      if (!vat?.isAgentAuthorisationApplied)
        tempErrors.vatAuthApplied = "This is required"

      if (vat?.isAgentAuthorisationApplied === "yes") {
        if (!vat?.agentAuthorisationAppliedDate)
          tempErrors.vatAuthAppliedDate = "This is required"
        if (!vat?.agentAuthorisationStatus)
          tempErrors.vatAuthStatus = "This is required"

        if (vat?.agentAuthorisationStatus === "Received") {
          if (!vat?.authorisationCode)
            tempErrors.vatAuthCode = "This is required"
        }
      }
      if (!VATFirstPeriod) {
        tempErrors.VATFirstPeriod = "First VAT Period End is required."
      }
      if (!VATFrequency) {
        tempErrors.VATFrequency = "VAT Frequency is required."
      }
    }

    if (
      utr?.status === "Received" ||
      cac?.status === "Received" ||
      paye?.status === "Received" ||
      vat?.status === "Received"
    ) {
      const allLinks = [
        utr?.letterLocation,
        cac?.letterLocation,
        paye?.letterLocation,
        vat?.letterLocation,
      ].filter(l => l)

      if (new Set(allLinks).size !== allLinks.length) {
        swal("", "Duplicate Letter Location Links found!", "warning")
        return false
      }
    }

    // if (!VATFirstPeriod) tempErrors.VATFirstPeriod = "Current Year VAT Due Date is required.";
    // if (!VATFrequency) tempErrors.VATFrequency = "Frequency is required.";
    // if (!VATCurrentPeriodEnd) tempErrors.VATCurrentPeriodEnd = "Next Year VAT Due Date is required.";

    if (clientType === 1 && !officerIdStatus)
      tempErrors.officerIdStatus = "Officer ID Status is required."

    if (officerIdStatus === "yes") {
      if (!officerId?.trim()) tempErrors.officerId = "Officer ID is required."
      else if (officerId.trim().length !== 27)
        tempErrors.officerId = "Officer ID must be exactly 27 characters."
    }

    if (!CISDate) tempErrors.CISDate = "CIS Date is required."
    if (!CISDueDate) tempErrors.CISDueDate = "CIS Due Date is required."

    // if (!payrollFrequency.length) tempErrors.payrollFrequency = "Payroll Frequency is required.";

    // if (payrollFrequency.some(p => p.value === "Weekly")) {
    //     if (!payrollWeeklyDate) tempErrors.payrollWeeklyDate = "Weekly Payroll Date is required.";
    // }
    // if (payrollFrequency.some(p => p.value === "Fortnightly")) {
    //     if (!payrollFortNightlyDate) tempErrors.payrollFortNightlyDate = "Fortnightly Payroll Date is required.";
    // }
    // if (payrollFrequency.some(p => p.value === "Fourweekly")) {
    //     if (!payrollForWeeklyDate) tempErrors.payrollForWeeklyDate = "For Weekly Payroll Date is required.";
    // }
    // if (payrollFrequency.some(p => p.value === "Monthly")) {
    //     if (!payrollMonthlyDate) tempErrors.payrollMonthlyDate = "Monthly Payroll Date is required.";
    // }

    setErrors(tempErrors)
    return Object.keys(tempErrors).length === 0
  }

  const handleSubmit = async () => {
    const isValid = validate()

    if (!isValid) {
      const vatHasError = [
        !vat?.number && vat?.status === "Received",
        !vat?.isApplied,
        vat?.isApplied === "yes" && !vat?.appliedDate,
        vat?.status === "Received" && !vat?.isAgentAuthorisationApplied,
        vat?.isAgentAuthorisationApplied === "yes" &&
          !vat?.agentAuthorisationAppliedDate,
        vat?.isAgentAuthorisationApplied === "yes" &&
          !vat?.agentAuthorisationStatus,
        vat?.isAgentAuthorisationApplied === "yes" &&
          vat?.agentAuthorisationStatus === "Received" &&
          !vat?.authorisationCode,
        vat?.status === "Received" && !VATFirstPeriod,
        vat?.status === "Received" && !VATFrequency,
      ].some(Boolean)

      if (vatHasError) {
        const vatSection = document.getElementById("vat-section")
        if (vatSection) {
          vatSection.scrollIntoView({ behavior: "smooth", block: "center" })
        } else {
          window.scrollTo({ top: 150, behavior: "smooth" })
        }
      } else if (
        officerIdStatus === "yes" &&
        (!officerId?.trim() || officerId.trim().length !== 27)
      ) {
        const officerSection = document.getElementById("officer-section")
        if (officerSection) {
          officerSection.scrollIntoView({ behavior: "smooth", block: "center" })
        }
      }
      window.scrollTo({ top: 100, behavior: "smooth" })
      return
    }
    if (!isReadOnly) {
      const setDate = date => (date === "Invalid date" ? null : date)

      const sendApplyDate = data =>
        data?.isApplied === "yes" ? setDate(data?.appliedDate) : null

      // conditionally data saving for [utr, cac, paye, vat]

      const sendReason = data =>
        data?.isAgentAuthorisationApplied === "no"
          ? data?.agentAuthorisationNotAppliedReason
          : null
      const sendAgentApplyDate = data =>
        data?.isAgentAuthorisationApplied === "yes"
          ? setDate(data?.agentAuthorisationAppliedDate)
          : null
      const sendAgentStatus = data =>
        data?.isAgentAuthorisationApplied === "yes"
          ? data?.agentAuthorisationStatus
          : null
      const sendCodeLetter = (data, field) =>
        data?.isAgentAuthorisationApplied === "yes" &&
        data?.agentAuthorisationStatus === "Received"
          ? data[field]
          : null

      swal({
        title: "Are you sure?",
        text: `You want to save this details to ${clientName}.`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async willDelete => {
        if (willDelete) {
          try {
            setLoading(true)
            const post_data = {
              // UTR
              UTRNumber: utr?.number,
              UTRStatus: utr?.status,
              letterLocationUTR: utr?.letterLocation,

              isUTRApplied: utr?.isApplied,
              UTRAppliedDate: sendApplyDate(utr),
              whyUTRNotApplicable: utr?.whyUTRNotApplicable || null,
              isUTRAgentAuthorisationApplied: utr?.isAgentAuthorisationApplied,
              UTRAgentAuthorisationAppliedDate: sendAgentApplyDate(utr),
              UTRAgentAuthorisationStatus: sendAgentStatus(utr),
              UTRAuthorisationCode: sendCodeLetter(utr, "authorisationCode"),
              UTRAgentAuthorisationLetterLocation: sendCodeLetter(
                utr,
                "agentAuthorisationLetterLocation"
              ),
              UTRAgentAuthorisationNotAppliedReason: sendReason(utr),

              // =============================

              // Personal Code
              personalCode: pc?.number,
              personalCodeStatus: pc?.status,
              letterLocationPersonalCode: pc?.letterLocation,
              isPersonalCodeApplied: pc?.isApplied,
              personalCodeAppliedDate: sendApplyDate(pc),
              whyPersonalCodeNotApplicable:
                pc?.whyPersonalCodeNotApplicable || null,

              // =============================

              // CAC
              CACNumber: cac?.number,
              CACStatus: cac?.status,
              letterLocationCAC: cac?.letterLocation,

              isCACApplied: cac?.isApplied,
              CACAppliedDate: sendApplyDate(cac),

              // isCACAgentAuthorisationApplied: cac?.isAgentAuthorisationApplied,
              // CACAgentAuthorisationAppliedDate: sendAgentApplyDate(cac),
              // CACAgentAuthorisationStatus: sendAgentStatus(cac),
              // CACAuthorisationCode: sendCodeLetter(cac, "authorisationCode"),
              // CACAgentAuthorisationLetterLocation: sendCodeLetter(
              //   cac,
              //   "agentAuthorisationLetterLocation"
              // ),
              // CACAgentAuthorisationNotAppliedReason: sendReason(cac),

              // =============================

              insuranceNumber: insurance?.number,
              insuranceStatus: insurance?.status,
              letterLocationInsurance: insurance?.letterLocation,

              // =============================

              // PAYE
              PAYENumber: paye?.number,
              PAYEStatus: paye?.status,
              letterLocationPAYE: paye?.letterLocation,
              officeReferencePAYE: paye?.officeReference,

              isPAYEApplied: paye?.isApplied,
              PAYEAppliedDate: sendApplyDate(paye),

              isPAYEAgentAuthorisationApplied:
                paye?.isAgentAuthorisationApplied,
              PAYEAgentAuthorisationAppliedDate: sendAgentApplyDate(paye),
              PAYEAgentAuthorisationStatus: sendAgentStatus(paye),
              PAYEAuthorisationCode: sendCodeLetter(paye, "authorisationCode"),
              PAYEAgentAuthorisationLetterLocation: sendCodeLetter(
                paye,
                "agentAuthorisationLetterLocation"
              ),
              PAYEAgentAuthorisationNotAppliedReason: sendReason(paye),

              // =============================

              // VAT
              VATNumber: vat?.number,
              VATStatus: vat?.status,
              letterLocationVAT: vat?.letterLocation,

              isVATApplied: vat?.isApplied,
              VATAppliedDate: sendApplyDate(vat),

              isVATAgentAuthorisationApplied: vat?.isAgentAuthorisationApplied,
              VATAgentAuthorisationAppliedDate: sendAgentApplyDate(vat),
              VATAgentAuthorisationStatus: sendAgentStatus(vat),
              VATAuthorisationCode: sendCodeLetter(vat, "authorisationCode"),
              VATAgentAuthorisationLetterLocation: sendCodeLetter(
                vat,
                "agentAuthorisationLetterLocation"
              ),
              VATAgentAuthorisationNotAppliedReason: sendReason(vat),

              // =============================

              officerIdStatus,
              officerId,

              accountsAndTaxCurrentYearDueDate,
              accountsAndTaxNextYearDueDate,

              VATFirstPeriod: VATFirstPeriod,
              VATFrequency: VATFrequency,
              VATCurrentPeriodEnd: VATCurrentPeriodEnd,
              VATCurrentPeriodDueDate: VATCurrentPeriodDueDate,

              CISDate: CISDate,
              CISDueDate: CISDueDate,
              PAYEDate,
              payrollFrequency: JSON.stringify(
                payrollFrequency.map(p => p.value)
              ),
              payrollFirstWeeklyDate: payrollWeeklyDate,
              payrollSecondWeeklyDate: payrollWeeklyDueDate,
              payrollFirstMonthlyDate: payrollMonthlyDate,
              payrollSecondMonthlyDate: payrollMonthlyDueDate,
              payrollFirstFourWeeklyDate: payrollForWeeklyDate,
              payrollSecondFourWeeklyDate: payrollForWeeklyDueDate,
              payrollFirstFortNightlyDate: payrollFortNightlyDate,
              payrollSecondFortNightlyDate: payrollFortNightlyDueDate,
            }

            const response = await axiosbaseurl.put(
              `/client/${clientId || client_id}`,
              post_data
            )

            if (response.data.success) {
              setAuditLogs(response.data.auditLogs)
              // setClientId(response.data.data.id)
              setIsChanged(prev => ({ ...prev, 3: false }))
              swal("", "Details saved successfully", "success").then(() => {
                changeStep()
              })
            }
          } catch (error) {
            console.log(error)
            const msg =
              error.response.data.message ||
              error.message ||
              "Something went Wrong"

            swal(
              "",
              msg,
              msg.includes("No changes were made !") ? "warning" : "error"
            )
          } finally {
            setLoading(false)
          }
        }
      })
    }
  }

  useEffect(() => {
    if (CISDate) {
      setDueCISDate(getFrequencyWiseDate(CISDate, "Fortnightly"))
    }
  }, [CISDate])

  // for payroll frequency
  useEffect(() => {
    if (payrollWeeklyDate) {
      setPayrollWeeklyDueDate(getFrequencyWiseDate(payrollWeeklyDate, "Weekly"))
    }
  }, [payrollWeeklyDate])

  useEffect(() => {
    if (payrollFortNightlyDate) {
      setPayrollFortNightlyDueDate(
        getFrequencyWiseDate(payrollFortNightlyDate, "Fortnightly")
      )
    }
  }, [payrollFortNightlyDate])

  useEffect(() => {
    if (payrollForWeeklyDate) {
      setPayrollForWeeklyDueDate(
        getFrequencyWiseDate(payrollForWeeklyDate, "Fourweekly")
      )
    }
  }, [payrollForWeeklyDate])

  useEffect(() => {
    if (payrollMonthlyDate) {
      setPayrollMonthlyDueDate(
        getFrequencyWiseDate(payrollMonthlyDate, "Monthly")
      )
    }
  }, [payrollMonthlyDate])

  // payroll frequency date calculation
  function getFrequencyWiseDate(datetime, frequency) {
    const date = moment(datetime) // Create a Moment object from the datetime string

    // Check frequency and calculate the date accordingly
    switch (frequency) {
      case "Weekly":
        date.add(7, "days") // Add 7 days
        break
      case "Fortnightly":
        date.add(14, "days") // Add 14 days
        break
      case "Fourweekly":
        date.add(28, "days") // Add 28 days
        break
      case "Monthly":
        date.add(1, "months") // Add 1 month
        date.endOf("month") // Set to the end of the next month

        // Manually set the time to match the original time (hours, minutes)
        const originalTime = moment(datetime) // To get the original time from input
        date.set({
          hour: originalTime.hour(),
          minute: originalTime.minute(),
        })
        break

      default:
        return datetime // Return the same date if no frequency matches
    }

    // Format the result back to the "yyyy-MM-ddThh:mm" format
    return date.format("YYYY-MM-DD")
  }

  useEffect(() => {
    if (!payrollFrequency.some(p => p.value === "Weekly")) {
      setPayrollWeeklyDate("")
      setPayrollWeeklyDueDate("")
    }
    if (!payrollFrequency.some(p => p.value === "Fortnightly")) {
      setPayrollFortNightlyDate("")
      setPayrollFortNightlyDueDate("")
    }
    if (!payrollFrequency.some(p => p.value === "Fourweekly")) {
      setPayrollForWeeklyDate("")
      setPayrollForWeeklyDueDate("")
    }
    if (!payrollFrequency.some(p => p.value === "Monthly")) {
      setPayrollMonthlyDate("")
      setPayrollMonthlyDueDate("")
    }
  }, [payrollFrequency])

  function formatKeyName(key) {
    return (
      key
        // Insert space between acronym (e.g. UTR) and next capitalized word
        .replace(/([A-Z]{2,})([A-Z][a-z])/g, "$1 $2")
        // Insert space between camelCase transitions
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        // Capitalize the first character
        .replace(/^./, str => str.toUpperCase())
    )
  }

  return (
    <>
      <div className="row">
        <div className="col-12">
          <AwaitingStatus
            title={"UTR Number"}
            setData={setUtr}
            data={utr}
            setShow={setShow}
            setHistoryType={setHistoryType}
            maxLength={10}
            isReadOnly={isReadOnly}
            numberValidate={errors?.utrNumber}
            statusValidate={errors?.utrStatus}
            letterValidate={errors?.utrletter}
            isAppliedValidate={errors?.utrIsApplied}
            appliedDateValidate={errors?.utrAppliedDate}
            authAppliedValidate={errors?.utrAuthApplied}
            authAppliedDateValidate={errors?.utrAuthAppliedDate}
            authStatusValidate={errors?.utrAuthStatus}
            authCodeValidate={errors?.utrAuthCode}
            notApplicableReasonValidate={errors?.utrNotApplicableReason}
          />
        </div>
        <div className="col-12">
          {clientType === 1 && (
            <AwaitingStatus
              title={"Personal Code"}
              setData={setPc}
              data={pc}
              setShow={setShow}
              maxLength={13}
              isReadOnly={isReadOnly}
              naReasonFieldName="whyPersonalCodeNotApplicable"
              numberValidate={errors?.pcNumber}
              statusValidate={errors?.pcStatus}
              letterValidate={errors?.pcletter}
              isAppliedValidate={errors?.pcIsApplied}
              appliedDateValidate={errors?.pcAppliedDate}
              notApplicableReasonValidate={errors?.pcNotApplicableReason}
            />
          )}
        </div>
        <div className="col-12">
          {clientType !== 1 && (
            <AwaitingStatus
              title={"CAC Number"}
              setData={setCac}
              data={cac}
              setShow={setShow}
              setHistoryType={setHistoryType}
              isReadOnly={isReadOnly}
              numberValidate={errors?.cacNumber}
              statusValidate={errors?.cacStatus}
              letterValidate={errors?.cacletter}
              isAppliedValidate={errors?.cacIsApplied}
              appliedDateValidate={errors?.cacAppliedDate}
              authAppliedValidate={errors?.cacAuthApplied}
              authAppliedDateValidate={errors?.cacAuthAppliedDate}
              authStatusValidate={errors?.cacAuthStatus}
              authCodeValidate={errors?.cacAuthCode}
            />
          )}
        </div>
        <div className="col-12">
          <AwaitingStatus
            title={"National Insurance Number"}
            setData={setInsurance}
            data={insurance}
            setShow={setShow}
            setHistoryType={setHistoryType}
            isReadOnly={isReadOnly}
            numberValidate={errors?.insuranceNumber}
            statusValidate={errors?.insuranceStatus}
            letterValidate={errors?.insuranceletter}
          />
        </div>
        <div className="col-12">
          <AwaitingStatus
            title={"PAYE Number"}
            setData={setPaye}
            data={paye}
            setShow={setShow}
            setHistoryType={setHistoryType}
            isReadOnly={isReadOnly}
            numberValidate={errors?.payeNumber}
            statusValidate={errors?.payeStatus}
            letterValidate={errors?.payeletter}
            officeReferenceValidate={errors?.payeReference}
            isAppliedValidate={errors?.payeIsApplied}
            appliedDateValidate={errors?.payeAppliedDate}
            authAppliedValidate={errors?.payeAuthApplied}
            authAppliedDateValidate={errors?.payeAuthAppliedDate}
            authStatusValidate={errors?.payeAuthStatus}
            authCodeValidate={errors?.payeAuthCode}
          />
        </div>
        <div className="col-12" id="vat-section">
          <AwaitingStatus
            title={"VAT Number"}
            setData={setVat}
            data={vat}
            setShow={setShow}
            setHistoryType={setHistoryType}
            isReadOnly={isReadOnly}
            numberValidate={errors?.vatNumber}
            statusValidate={errors?.vatStatus}
            letterValidate={errors?.vatletter}
            isAppliedValidate={errors?.vatIsApplied}
            appliedDateValidate={errors?.vatAppliedDate}
            authAppliedValidate={errors?.vatAuthApplied}
            authAppliedDateValidate={errors?.vatAuthAppliedDate}
            authStatusValidate={errors?.vatAuthStatus}
            authCodeValidate={errors?.vatAuthCode}
            // Pass VAT date props for merging
            vatFirstPeriod={VATFirstPeriod}
            setVatFirstPeriod={setVATFirstPeriod}
            vatFrequency={VATFrequency}
            setVatFrequency={setVATFrequency}
            vatCurrentPeriodEnd={VATCurrentPeriodEnd}
            setVatCurrentPeriodEnd={setVATCurrentPeriodEnd}
            vatCurrentPeriodDueDate={VATCurrentPeriodDueDate}
            setVatCurrentPeriodDueDate={setVATCurrentPeriodDueDate}
            isVatPresent={isVatPresent}
            setVatPresent={setVatPresent}
            static_frequency={static_frequency}
            vatFirstPeriodError={errors?.VATFirstPeriod}
            vatFrequencyError={errors?.VATFrequency}
          />
        </div>
      </div>

      {/*MTD IT Date only for Individuals */}
      {clientType === 1 && (
        <Card>
          <CardBody>
            <div className="row">
              <h4 className="fw-bold mb-4">MTD</h4>

              <div className="col-md-4 mb-md-1 mb-3">
                <label>Current MTD Period End</label>
                <input
                  type="date"
                  value={currentMTDPeriodEnd}
                  className="form-control input-field"
                  readOnly
                />
              </div>
              <div className="col-md-4 mb-md-1 mb-3">
                <label>Current MTD Period Due Date</label>
                <input
                  type="date"
                  value={currentMTDPeriodDue}
                  className="form-control input-field"
                  readOnly
                />
              </div>
            </div>
          </CardBody>
        </Card>
      )}

      {/*Officer ID only for Individuals */}
      {clientType === 1 && (
        <Card id="officer-section">
          <CardBody>
            <div className="row">
              <h4 className="fw-bold mb-4">Officer</h4>
              <div className="col-md-4 mb-md-1 mb-3">
                <label>Officer ID Status <span className="text-danger">*</span></label>
                <select
                  value={officerIdStatus}
                  onChange={e => setOfficerIdStatus(e.target.value)}
                  className="form-control input-field"
                  disabled={isReadOnly}
                >
                  <option value="">Select Status</option>
                  <option value="yes">Listed on CH</option>
                  <option value="no">N/A</option>
                </select>
                <span className="error">{errors?.officerIdStatus}</span>
              </div>
              {officerIdStatus === "yes" && (
                <div className="col-md-4 mb-md-1 mb-3">
                  <label>
                    Officer ID
                    {officerIdStatus === "yes" && (
                      <span className="text-danger"> *</span>
                    )}
                  </label>
                  <input
                    type="text"
                    value={officerId}
                    onChange={e => setOfficerId(e.target.value)}
                    className="form-control input-field"
                    maxLength={27}
                    disabled={isReadOnly}
                    placeholder="Enter Officer ID (27 characters)"
                  />
                  <span className="error">{errors?.officerId}</span>
                </div>
              )}
            </div>
          </CardBody>
        </Card>
      )}

      {/*Accounts & Tax Return */}
      <Card>
        <CardBody>
          <div className="row">
            <h4 className="fw-bold mb-4">Accounts & Tax Return</h4>

            <div className="col-md-4 mb-md-1 mb-3">
              <label>Current Year End</label>
              <input
                type="date"
                value={accountsAndTaxCurrentYearDueDate}
                onChange={e =>
                  setAccountsAndTaxCurrentYearDueDate(e.target.value)
                }
                className="form-control input-field"
                readOnly
              />
            </div>
            <div className="col-md-4 mb-md-1 mb-3">
              <label>Current Financial/Tax Year Due</label>
              <input
                type="date"
                value={accountsAndTaxNextYearDueDate}
                onChange={e => setAccountsAndTaxNextYearDueDate(e.target.value)}
                className="form-control input-field"
                readOnly
              />
            </div>
          </div>
        </CardBody>
      </Card>

      {/*CIS Return */}
      <Card>
        <CardBody>
          <div className="row">
            <h4 className="fw-bold mb-4">CIS Return</h4>

            <div className="col-md-4 mb-md-1 mb-3">
              <label>
                Current Period End <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                value={CISDate}
                // onChange={(e) => {
                //     const localDateTime = e.target.value;
                //     setCISDate(localDateTime)
                // }}
                readOnly
                className="form-control input-field"
              />
              <span className="error">{errors.CISDate}</span>
            </div>

            <div className="col-md-4 mb-md-1 mb-3">
              <label>CIS Frequency</label>
              <div className="form-control input-field view-field text-capitalize">
                {CISFrequency || "Monthly"}
              </div>
            </div>

            <div className="col-md-4 mb-md-1 mb-3">
              <label>Current period due date</label>
              <input
                type="date"
                value={CISDueDate}
                readOnly
                className="form-control input-field"
              />
            </div>

            {/* <div className="col-md-4 mb-md-1 mb-3">
                            <label>PAYE</label>
                            <input type='date'
                                value={PAYEDate}
                                onChange={(e) => setPAYEDate(e.target.value)}
                                className="form-control input-field" />
                        </div> */}

            {/* <div className="col-md-4 mb-3">
                            <label>Payroll Frequency</label>
                            <select className="form-select input-field"
                                value={payrollFrequency}
                                onChange={(e) => setpayrollFrequency(e.target.value)}
                            >
                                <option value="">Select Payroll Frequency</option>
                                {
                                    payroll_freq_options?.map((option) => (
                                        <option key={option.id} value={option.id}>{option.payrollFrequency}</option>
                                    ))
                                }
                            </select>
                        </div> */}
          </div>
        </CardBody>
      </Card>

      {!isReadOnly ? (
        <Card>
          <CardBody>
            <LoadingButton
              loading={loading}
              btnText="Save & Next"
              icon_2={<i className="fas fa-arrow-right ms-3"></i>}
              handler={handleSubmit}
            />
          </CardBody>
        </Card>
      ) : null}

      <Modal
        size="xl"
        isOpen={show}
        toggle={() => setShow(!show)}
        centered={true}
      >
        <div className="modal-content">
          <ModalBody className="px-3 ">
            <div className="d-flex justify-content-between">
              <h5>Updated History</h5>
              <button
                type="button"
                className="btn-close "
                onClick={() => setShow(!show)}
              ></button>
            </div>
            <div
              style={{
                maxHeight: "500px",
                overflow: "auto",
                scrollbarWidth: "thin",
              }}
            >
              <table className="table mt-3" style={{ verticalAlign: "middle" }}>
                <thead className="table-primary">
                  <tr>
                    <th>#</th>
                    <th>Updated At</th>
                    <th>Updated By</th>
                    <th>Previous Data</th>
                    <th>Updated Data</th>
                  </tr>
                </thead>
                <tbody>
                  {history?.reverse().map((item, i) => (
                    <tr key={item.id}>
                      <td>{i + 1}</td>
                      <td>
                        {moment(item.createdAt).format(
                          "DD MMM YYYY | hh:mm  A"
                        )}
                      </td>
                      <td>{item.updatedBy}</td>
                      <td>
                        <table border="1" className="table">
                          <tbody className="table-light">
                            {Object.entries(JSON.parse(item?.previousData)).map(
                              ([key, value]) => (
                                <tr key={key}>
                                  <th className="py-2 col-6 ">
                                    {formatKeyName(key)}
                                  </th>
                                  <td className="py-2 col-6">
                                    {moment(value).format("DD MMMM, YYYY ") !==
                                      "Invalid date" &&
                                    value.length > 8 &&
                                    value.includes("-") ? (
                                      moment(value).format("DD MMMM, YYYY ")
                                    ) : (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: value || "--",
                                        }}
                                        style={{ textWrap: "wrap" }}
                                      />
                                    )}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </td>
                      <td>
                        <table border="1" className="table">
                          <tbody className="table-light">
                            {Object.entries(JSON.parse(item?.updatedData)).map(
                              ([key, value]) => (
                                <tr key={key}>
                                  <th className="py-2 col-6 ">
                                    {formatKeyName(key)}
                                  </th>
                                  <td className="py-2 col-6">
                                    {moment(value).format("DD MMMM, YYYY ") !==
                                      "Invalid date" &&
                                    value.length > 8 &&
                                    value.includes("-") ? (
                                      moment(value).format("DD MMMM, YYYY ")
                                    ) : (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: value || "--",
                                        }}
                                        style={{ textWrap: "wrap" }}
                                      />
                                    )}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  )
}

function AwaitingStatus({
  title,
  setData,
  data,
  setShow,
  setHistoryType,
  maxLength,
  numberValidate,
  statusValidate,
  letterValidate,
  officeReferenceValidate,
  isAppliedValidate,
  appliedDateValidate,
  authAppliedValidate,
  authAppliedDateValidate,
  authStatusValidate,
  authCodeValidate,
  notApplicableReasonValidate,
  naReasonFieldName = "whyUTRNotApplicable",
  isReadOnly,
  // New props for VAT merging
  vatFirstPeriod,
  setVatFirstPeriod,
  vatFrequency,
  setVatFrequency,
  vatCurrentPeriodEnd,
  setVatCurrentPeriodEnd,
  vatCurrentPeriodDueDate,
  setVatCurrentPeriodDueDate,
  isVatPresent,
  setVatPresent,
  static_frequency,
  vatFirstPeriodError,
  vatFrequencyError,
}) {
  const first_word =
    title.split(" ").length > 2
      ? title.split(" ").slice(0, 2).join(" ")
      : title.split(" ")[0]

  const handleSetData = e => {
    const { name, value } = e.target

    setData(prev => {
      const newData = {
        ...prev,
        [name]: value.trimStart(),
      }

      if (name === "status" && value !== "Received") {
        newData.number = ""
        newData.letterLocation = ""
      }

      if (name === "status" && value !== "N/A") {
        newData[naReasonFieldName] = ""
      }

      return newData
    })
  }

  const isOfficeRef = Object.keys(data).includes("officeReference")
  const isAstric = <span className="text-danger">*</span>

  const onlyNumeric = ["UTR", "VAT"]

  const isVatCard = title === "VAT Number"
  const isVatReceived = isVatCard && data?.status === "Received"

  return (
    <Card>
      <CardBody>
        <div className="row">
          <div className="d-flex justify-content-between">
            <h4 className="fw-bold mb-4">
              {title !== "Personal Code" ? first_word : "Personal Code"}
            </h4>
            <div>
              {title !== "Personal Code" && (
                <div
                  className="text-small text-end fw-semibold fst-italic text-muted mb-1"
                  title="Last Follow Up Trigger Date"
                >
                  <i className="bx bx-info-circle text-warning"></i>{" "}
                  {moment(data?.follow_up_date).format("DD MMM YYYY") ===
                  "Invalid date"
                    ? "No follow up scheduled"
                    : moment(data?.follow_up_date).format("DD MMM YYYY")}
                </div>
              )}

              {setHistoryType && (
                <button
                  type="button"
                  className="btn btn-sm btn-light"
                  onClick={() => {
                    setHistoryType(
                      first_word == "National Insurance"
                        ? "Insurance"
                        : first_word
                    )
                    setShow(true)
                  }}
                >
                  <i className="bx bx-history me-1"></i> Updated History
                </button>
              )}
            </div>
          </div>

          {title !== "National Insurance Number" ? (
            <div className="col-12 mb-4">
              <div className="row">
                <div className={`col-md-${"5"} mb-md-1 mb-3`}>
                  <label>
                    Did we apply, or ask for the reference to be resent?{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select input-field"
                    value={data?.isApplied}
                    disabled={isReadOnly}
                    name="isApplied"
                    onChange={handleSetData}
                  >
                    <option value="">Select </option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                  <span className="error">{isAppliedValidate}</span>
                </div>
                {data?.isApplied === "yes" && (
                  <div className="col-md-4">
                    <label htmlFor="#">
                      What date did we apply?{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="date"
                      className="form-control input-field"
                      value={data?.appliedDate}
                      disabled={isReadOnly}
                      name="appliedDate"
                      onChange={handleSetData}
                    />
                    <span className="error">{appliedDateValidate}</span>
                  </div>
                )}
              </div>
            </div>
          ) : null}

          <div className={`col-md-${"3"} mb-md-1 mb-3`}>
            <label>
              {first_word} Status {title === "UTR Number" && isAstric}
            </label>
            <select
              className="form-select input-field"
              value={data?.status}
              disabled={isReadOnly}
              name="status"
              onChange={handleSetData}
            >
              <option value="">Select </option>
              <option value="Awaiting Client">Awaiting Client</option>
              <option value="Received">Received</option>
              {(title === "UTR Number" || title === "Personal Code") && (
                <option value="N/A">N/A</option>
              )}
            </select>
            <span className="error">{statusValidate}</span>
          </div>

          {data?.status === "N/A" && (
            <>
              <div className={`col-md-${"3"} mb-md-1 mb-3`}>
                <label>Why is the reference not applicable? {isAstric}</label>

                <input
                  type="text"
                  className="form-control input-field"
                  placeholder={`Enter reason`}
                  name={naReasonFieldName}
                  disabled={isReadOnly}
                  value={data?.[naReasonFieldName]}
                  onChange={handleSetData}
                />
                <span className="error">{notApplicableReasonValidate}</span>
              </div>
            </>
          )}

          {data?.status === "Received" && (
            <>
              <div className={`col-md-${"3"} mb-md-1 mb-3`}>
                <label>
                  {title} {isAstric}
                </label>

                <input
                  type="text"
                  className="form-control input-field"
                  placeholder={`Enter ${first_word} Number`}
                  name="number"
                  disabled={isReadOnly}
                  value={data?.number}
                  onChange={handleSetData}
                  maxLength={maxLength}
                  {...(onlyNumeric.includes(first_word)
                    ? { onKeyPress: validateContact, onBlur: sanitizeNumber }
                    : {})}
                />
                <span className="error">{numberValidate}</span>
              </div>

              {isOfficeRef && (
                <div className={`col-md-${"3"} mb-md-1 mb-3`}>
                  <label>
                    {"Office Reference"} {isAstric}
                  </label>

                  <input
                    type="text"
                    className="form-control input-field"
                    placeholder={`Enter Office Reference`}
                    name="officeReference"
                    disabled={isReadOnly}
                    value={data?.officeReference}
                    onChange={handleSetData}
                    maxLength={maxLength}
                  />
                  <span className="error">{officeReferenceValidate}</span>
                </div>
              )}

              <div className={`col-md-${isOfficeRef ? "3" : "6"} mb-md-1 mb-3`}>
                <label> Letter Location on OneDrive</label>
                <input
                  type="text"
                  className="form-control input-field"
                  placeholder={`E.g. https://onedrive...`}
                  name="letterLocation"
                  disabled={isReadOnly}
                  value={data?.letterLocation}
                  onChange={handleSetData}
                />
                <span className="error">{letterValidate}</span>
              </div>
            </>
          )}

          {/* ==================== MERGED VAT DATES SECTION ==================== */}
          {isVatCard && (
            <div>
              <VATServiceDateCalculate
                firstPeriodEnd={vatFirstPeriod}
                setFirstPeriodEnd={setVatFirstPeriod}
                frequency={vatFrequency}
                setFrequency={setVatFrequency}
                currentPeriodEnd={vatCurrentPeriodEnd}
                setCurrentPeriodEnd={setVatCurrentPeriodEnd}
                currentPeriodDue={vatCurrentPeriodDueDate}
                setCurrentPeriodDue={setVatCurrentPeriodDueDate}
                label1={`First VAT Period End${isVatReceived ? " " : ""}`}
                label2={`VAT Frequency${isVatReceived ? " " : ""}`}
                label3="Current VAT Period End"
                label4="Current Period Due Date"
                static_frequency={static_frequency}
                isReadOnly={isReadOnly}
                datePresent={isVatPresent}
                setDatePresent={setVatPresent}
                firstPeriodError={vatFirstPeriodError}
                frequencyError={vatFrequencyError}
              />
            </div>
          )}

          {title !== "National Insurance Number" &&
          title !== "CAC Number" &&
          title !== "Personal Code" ? (
            <div className="col-12 mt-4">
              <div className="row">
                <div className={`col-md-${"5"} mb-md-1 mb-3`}>
                  <label>
                    Have we applied for agent authorisation?
                    {data?.status === "Received" && (
                      <span className="text-danger"> *</span>
                    )}
                  </label>
                  <select
                    className="form-select input-field"
                    value={data?.isAgentAuthorisationApplied}
                    disabled={isReadOnly}
                    name="isAgentAuthorisationApplied"
                    onChange={handleSetData}
                  >
                    <option value="">Select </option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                  <span className="error">{authAppliedValidate}</span>
                </div>

                {data?.isAgentAuthorisationApplied === "no" ? (
                  <div className="col-md-7">
                    <label htmlFor="#">
                      Why haven't we apply applied for agent authorisation?{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control input-field"
                      placeholder="Why haven't we apply applied for agent authorisation?"
                      value={data?.agentAuthorisationNotAppliedReason}
                      disabled={isReadOnly}
                      name="agentAuthorisationNotAppliedReason"
                      onChange={handleSetData}
                    />
                  </div>
                ) : null}

                {data?.isAgentAuthorisationApplied === "yes" ? (
                  <>
                    <div className="col-md-4">
                      <label htmlFor="#">
                        What date did we apply?{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control input-field"
                        value={data?.agentAuthorisationAppliedDate}
                        disabled={isReadOnly}
                        name="agentAuthorisationAppliedDate"
                        onChange={handleSetData}
                      />
                      <span className="error">{authAppliedDateValidate}</span>
                    </div>

                    <div className="col-12">
                      <div className="row">
                        <div className={`col-md-3 mt-4`}>
                          <label>
                            {String(title).split(" ")[0]} Agent Authorisation
                            Status
                          </label>{" "}
                          <span className="text-danger">*</span>
                          <select
                            className="form-select input-field"
                            value={data?.agentAuthorisationStatus}
                            disabled={isReadOnly}
                            name="agentAuthorisationStatus"
                            onChange={handleSetData}
                          >
                            <option value="">Select </option>
                            <option value="Received">Received</option>
                            <option value="Awaiting Client">
                              Awaiting Client
                            </option>
                          </select>
                          <span className="error">{authStatusValidate}</span>
                        </div>

                        {data?.agentAuthorisationStatus === "Received" ? (
                          <>
                            <div className="col-md-3 mt-4">
                              <label htmlFor="#">
                                Authorisation code
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control input-field"
                                placeholder="Enter here"
                                value={data?.authorisationCode}
                                disabled={isReadOnly}
                                name="authorisationCode"
                                onChange={handleSetData}
                              />
                              <span className="error">{authCodeValidate}</span>
                            </div>

                            <div className={`col-md-6 mt-4`}>
                              <label> Letter Location on OneDrive</label>
                              <input
                                type="text"
                                className="form-control input-field"
                                placeholder={`E.g. https://onedrive...`}
                                name="agentAuthorisationLetterLocation"
                                disabled={isReadOnly}
                                value={data?.agentAuthorisationLetterLocation}
                                onChange={handleSetData}
                              />
                              <span className="error">{letterValidate}</span>
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>
      </CardBody>
    </Card>
  )
}

export default TaxReferences
